<template>
  <TextField
    :id="`tender-name-${planType}-${index}`"
    :name="fieldName"
    :label="t('sites.singleSite.financialConfig.mealPlans.form.tenders.tenderName')"
    :placeholder="
      t('sites.singleSite.financialConfig.mealPlans.form.tenders.tenderNamePlaceholder')
    "
    :required="!isDisabled"
    :disabled="isDisabled"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

// Define props
defineProps({
  fieldName: {
    type: String,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  planType: {
    type: String,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
});

// Set localization
const { t } = useI18n();
</script>
